/* DON'T EDIT THIS FILE: edit original and run build again */ export type MaybeArray<T> = T | T[];

export const toArray = <T>(maybeArray: MaybeArray<T>): T[] => {
  if (Array.isArray(maybeArray)) {
    return maybeArray;
  }
  return [maybeArray];
};
